function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { classNames, getExtraAttrs, emit } from '../shared/utils';
import { colorClasses } from '../shared/mixins';
import { useTheme } from '../shared/use-theme';
import Link from './link';

var NavLeft = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      id = props.id,
      style = props.style,
      children = props.children,
      backLink = props.backLink,
      backLinkUrl = props.backLinkUrl,
      backLinkForce = props.backLinkForce,
      backLinkShowText = props.backLinkShowText,
      sliding = props.sliding;
  var extraAttrs = getExtraAttrs(props);
  var elRef = useRef(null);

  var onBackClick = function onBackClick(event) {
    emit(props, 'backClick clickBack', event);
  };

  useImperativeHandle(ref, function () {
    return {
      el: elRef.current
    };
  });
  var theme = useTheme();
  var linkEl;
  var needBackLinkText = backLinkShowText;
  if (typeof needBackLinkText === 'undefined') needBackLinkText = !theme.md;

  if (backLink) {
    var text = backLink !== true && needBackLinkText ? backLink : undefined;
    linkEl = /*#__PURE__*/React.createElement(Link, {
      href: backLinkUrl || '#',
      back: true,
      icon: "icon-back",
      force: backLinkForce || undefined,
      className: !text ? 'icon-only' : undefined,
      text: text,
      onClick: onBackClick
    });
  }

  var classes = classNames(className, 'left', {
    sliding: sliding
  }, colorClasses(props));
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    style: style,
    className: classes,
    ref: elRef
  }, extraAttrs), linkEl, children);
});
NavLeft.displayName = 'f7-nav-left';
export default NavLeft;